import script from "./basicData.vue?vue&type=script&setup=true&lang=js"
export * from "./basicData.vue?vue&type=script&setup=true&lang=js"

import "./basicData.vue?vue&type=style&index=0&id=7b60561e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b60561e"]])

export default __exports__